module.exports = __webpack_public_path__ + "img/photo13.5bacc050.jpg";